/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import "./loginModalv2Popup.scss";
// react router dom
import { Link, useHistory, useParams, useLocation } from "react-router-dom";
// localizations
import { withTranslation, useTranslation } from "react-i18next";
// import Redux
import { useDispatch, useSelector } from "react-redux";
// material ui
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DoneIcon from "@mui/icons-material/Done";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
// svg icons
import IMAGES from "../Assets/images2";
import InputMaskField from "../../sharedComponent/react-input-mask/inputfield";
import Page from "../../layout-one/js/components/Page";
import Backdrop from "@mui/material/Backdrop";
import leftArrow from "../../layout-three/js/assets/images/leftArrow.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Axios from "axios";
import CircularIndeterminate from "../../layout-one/js/components/CircularIndeterminate";
//  cookie functions
import { getCookie, setCookie } from "../../global-functions/cookieFunction";
import { freezOn, freezOff, handleError } from "../../redux-store/action";
import TextField from "@mui/material/TextField";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { checkNameRequired } from "../../global-functions/loginAllow";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux-store/store";
import { formatKuwaitiMobile } from "../../utils/genral-functions";
import { useMediaQuery } from "@material-ui/core";
import { Countries, phonePatterns, getMaxDigits, validatePhoneNumber, getMaskPattern } from "../../utils/phoneValidation";
function LoginModalv2Popup(props) {
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();
  const {
    setGuestLoggedIn,
    setLoginModal,
    setLoginSkip,
    setLoginState,
    setFreezScreen,
    setLangValue,
    setGuestModal,
  } = bindActionCreators(actionCreators, appDispatch);
  const [fullWidth] = React.useState(true);
  const history = useHistory();
  // const navigate = useNavigate();
  const appName =  process.env.REACT_APP_NAME;
  const slugFromEnv = appName !== "null" ? appName : null;
  const deliveryCheckoutUrl =
    (slugFromEnv
      ? window.location.pathname == `/checkout`
      : window.location.pathname == `/${appState.storeInfo?.slug}/checkout`) &&
    appState.deliveryMode
      ? true
      : false;
  const [loading, setLoading] = useState(false);
  const min450 = useMediaQuery("(min-width:450px)");

  const [loginValues, setLoginValues] = useState({
    phoneCode: appState.loginValues?.phoneCode || "965",
    phoneNumber: appState.loginValues?.phoneNumber
      ? appState.loginValues?.phoneNumber
      : "",
    fullName: appState.loginValues?.fullName
      ? appState.loginValues?.fullName
      : "",
    email: appState.loginValues?.email ? appState.loginValues?.email : "",
  });
  
  // ✅ Country and phone validation state
  const [selectedCountry, setSelectedCountry] = useState(() => {
    // Initialize with country from appState.loginValues or default to Kuwait
    const phoneCode = appState.loginValues?.phoneCode || "965";
    const savedCountry = Countries.find(c => c.dial_code === `+${phoneCode}`) || Countries[0];
    return savedCountry;
  });
  const [phoneError, setPhoneError] = useState("");
  const [countryMenuAnchor, setCountryMenuAnchor] = useState(null);
  
  // Handle country change
  const handleCountryChange = (countryCode) => {
    const country = Countries.find(c => c.code === countryCode) || Countries[0];
    setSelectedCountry(country);
    
    // Update phone code in loginValues
    const newPhoneCode = country.dial_code.replace('+', '');
    const updatedValues = {
      ...loginValues,
      phoneCode: newPhoneCode,
      phoneNumber: "", // Clear phone number when country changes
    };
    setLoginValues(updatedValues);
    setLoginState(updatedValues);
    
    // Clear phone error when country changes
    setPhoneError("");
    setCountryMenuAnchor(null); // Close menu
  };

  const handleCountryMenuOpen = (event) => {
    setCountryMenuAnchor(event.currentTarget);
  };

  const handleCountryMenuClose = () => {
    setCountryMenuAnchor(null);
  };
  
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const [success, setSuccess] = useState(false);
  const handleClose = () => {
    setLoginModal(false);
  };

  const handleSkip = () => {
    setLoginSkip(true);
    setLoginModal(false);
  };
  console.log(appState?.qrBranch, "appState?.qrBranch");
  console.log(appState?.storeInfo?.storeId, "appState?.storeInfo?.storeId");
  const handleGuestLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setFreezScreen(true);

    // // appDispatch({ type: "setLoginSkip", loginSkip: false });
    // // setGuestLoggedIn(true);
    // // setLoginModal(false)
    // // setGuestModal(true)
    // // appDispatch({
    // //   type: "SET_LOGIN",
    // //   loggedIn: false,
    // //   loginToken: '',
    // // });
    // let kuwaitNumbre =
    //   appState.loginValues?.phoneNumber != ""
    //     ? formatKuwaitiMobile(appState.loginValues?.phoneNumber)
    //     : null;
    // // let kuwaitNumbre = true;
    let validation = validatePhoneNumber(loginValues.phoneNumber, selectedCountry.code);
    if (
      loginValues?.phoneCode &&
      loginValues?.phoneNumber !== "" &&
      (loginValues?.fullName !== "" ||
        appState.storeInfo.lavazzaStoreOptions) &&
      validation.isValid
    ) {
      setLoginState(loginValues);
      appDispatch({ type: "setLoginSkip", loginSkip: false });
      setGuestLoggedIn(true);
      setLoginModal(false);
      appDispatch({
        type: "SET_LOGOUT",
        loggedIn: false,
      });
      if (appState.deliveryMode && appState.pickupOrDelivery == "delivery") {
        history.push("/address-form");
      }
      setFreezScreen(false)
      setLoading(false);  

    } else {
      setFreezScreen(false);
      setLoading(false);
      appDispatch({
        type: "SHOW_ALERT",
        alertType: "error",
        message:
          kuwaitNumbre == null
            ? t("Please give correct phone number.")
            : appState.loginValues?.phoneNumber == "" &&
              appState.loginValues?.fullName == ""
            ? t("Phone Number and Full Name is required")
            : appState.loginValues?.phoneNumber == ""
            ? t("Phone Number  is required")
            : t("Full Name is required"),
      });
    }
  };

  const date = new Date();
  let year = date.getFullYear();

  // ✅ Enhanced phone number validation
  const updateField = (event) => {
    const { name, value } = event.target;

    if (name === "phoneNumber") {
      const maxDigits = getMaxDigits(selectedCountry.code);
      const currentLength = loginValues.phoneNumber?.length || 0;
      
      // ✅ Allow deletion (value length decreasing) or if within max limit
      const isDeleting = value.length < currentLength;
      const isWithinLimit = value.length <= maxDigits;
      
      if (isDeleting || isWithinLimit) {
        setLoginValues({
          ...loginValues,
          [name]: value,
        });
        setLoginState({
          ...loginValues,
          [name]: value,
        });

        // ✅ Live validation
        if (value.length > 0) {
          const validation = validatePhoneNumber(value, selectedCountry.code);
          setPhoneError(validation.error);
        } else {
          setPhoneError("");
        }
      }
    } else {
      setLoginValues({
        ...loginValues,
        [name]: value,
      });
      setLoginState({
        ...loginValues,
        [name]: value,
      });
    }
  };

  const handleGuest = () => {};
  const phoneLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setFreezScreen(true);
    setLoginState(loginValues);
    if (loginValues?.phoneCode && loginValues?.phoneNumber !== "" && validatePhoneNumber(loginValues.phoneNumber, selectedCountry.code).isValid) {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}/send/guest/otp`,
          {
            branch_id: appState?.qrBranch ||  null, 
            store_id: appState?.storeInfo?.storeId || null,  
            country_code: loginValues.phoneCode,
            number: loginValues.phoneNumber,
            provider: appState?.storeInfo?.branch?.provider,
            
          }
        );
        setLoading(false);
        if (response.data.data === true) {
          setLoading(false);
          setFreezScreen(false);
          appDispatch({
            type: "SHOW_ALERT",
            alertType: "success",
            message: response.data.message,
          });
          setLoginModal(false);
          appDispatch({ type: "setOtpModal", otpModal: true });
        } else {
          setLoading(false);
          appDispatch({
            type: "SHOW_ALERT",
            alertType: "error",
            message: response.data.message,
          });
          setFreezScreen(false);
        }
      } catch (e) {
        setFreezScreen(false);

        setLoading(false);
        if (e == undefined) {
          appDispatch({
            type: "SHOW_ALERT",
            alertType: "warning",
            message: "Please check your network.",
          });
        } else {
          appDispatch(handleError(e));
        }
      }
    } else {
      setFreezScreen(false);
      setLoading(false);
      appDispatch({
        type: "SHOW_ALERT",
        alertType: "error",
        message: validatePhoneNumber(loginValues.phoneNumber, selectedCountry.code).error || t("Login.plz-fill-required-fields"),
      });
    }
  };

  const guestLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setFreezScreen(true);
    setLoginState(loginValues);
    if (
      loginValues?.phoneCode &&
      loginValues?.phoneNumber !== "" &&
      loginValues?.fullName !== ""
    ) {
      if (formatKuwaitiMobile(`${loginValues?.phoneNumber}`)) {
        setFreezScreen(false);
        setGuestLoggedIn(false);
        setLoginModal(false);
        setGuestModal(false);
        if (appState.pickupOrDelivery == "delivery") {
          history.push("/address-form");
        }
      } else {
        appDispatch({
          type: "SHOW_ALERT",
          alertType: "error",
          message: t("Number Format is not valid"),
        });
        setFreezScreen(false);
        setLoading(false);
      }
    } else {
      setFreezScreen(false);
      setLoading(false);
      appDispatch({
        type: "SHOW_ALERT",
        alertType: "error",
        message: t("Name and phone number are required for guest."),
      });
    }
  };

  return (
    <>
      <div
        id="mySidenav"
        className={`loginModalMainv2popup col-12 py-3   ${
          appState.langValue == "ar" ? "loginModalMainv2popupArabic" : " "
        }`}
      >
        {loading && (
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 15,
            }}
            open={loading}
          >
            <CircularIndeterminate />
          </Backdrop>
        )}
        <div className={`${appState.langValue === "ar" ? "directionRtl" : ""}`}>
          <div className="row pt-2 mx-0 ">
            <div
              className={`col-md-12 px-0 d-flex  classforPaddinglogo ${"justify-content-between"}`}
            >
              {
                <Button
                  onClick={handleClose}
                  variant="contained"
                  className="BackBtn"
                >
                  {appState.langValue === "ar" ? (
                    <ArrowForwardIcon />
                  ) : (
                    <ArrowBackIcon />
                  )}
                </Button>
              }
              <div>
                {appState.langValue === "ar" ? (
                  <Button
                    className="px-5  arabicBtn"
                    variant="contained"
                    onClick={(e) => setLangValue(`en`)}
                  >
                    English
                  </Button>
                ) : (
                  <Button
                    className="px-5  arabicBtn"
                    variant="contained"
                    onClick={(e) => setLangValue(`ar`)}
                  >
                    العربيه
                  </Button>
                )}
              </div>
            </div>
          </div>
          <div className="row mt-3 mx-0 ">
            <div className="col-md-12 px-0 d-flex classforPaddinglogo  d-flex aling-items-center justify-content-between">
              <span>
                <h1
                  className={`familyManrope800 mt-1  ${
                    appState.langValue === "ar" ? "d-flex" : ""
                  }`}
                >
                  {t("Login.Verify-Your-Mobile-Number")}
                </h1>
                <p
                  className={`familyManrope600 mt-1 textf4f4 ${
                    appState.langValue === "ar" ? "d-flex" : ""
                  }`}
                >
                  {t("Login.You-will-recieve-a-one-time-password-shortly")}
                </p>
              </span>

              <img src={IMAGES.enabill} alt="enabill-logo" />
            </div>
          </div>

          <form onSubmit={appState.storeInfo?.lavazzaStoreOptions || appState.storeInfo?.karakStoreOptions ? handleGuestLogin : phoneLogin}>
            <div className={`classforPaddingTextfield ${appState.langValue === "ar" ? "classforArabicPhone" : ""}`} >
              <div className={`row mt-3  ${appState.langValue === "ar" ? "classforArabicPhoneField" : ""}`} >
                <div className="col-12">
                  <InputMaskField
                    value={loginValues?.phoneNumber}
                    onChange={updateField}
                    inputProps={{ inputMode: "numeric", autoComplete: "off" }}
                    autoFocus={false}
                    autoComplete="off"
                    label={t("Forms.phone-number")}
                    className="mt-2"
                    variant="outlined"
                    type="tel"
                    mask={getMaskPattern(selectedCountry.code)}
                    id="outlined-basic"
                    name="phoneNumber"
                    error={!!phoneError}
                    helperText={phoneError}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <div 
                            onClick={handleCountryMenuOpen}
                            style={{ 
                              display: "flex", 
                              alignItems: "center", 
                              cursor: "pointer",
                              paddingRight: "8px",
                              borderRight: "1px solid rgba(0, 0, 0, 0.23)",
                              marginRight: "8px",
                              // zIndex: 9999
                            }}
                          >
                            <img
                              className="inputadornmentImg flagImg"
                              src={selectedCountry.flag}
                              alt={selectedCountry.name}
                              style={{
                                width: "24px",
                                height: "18px",
                                marginRight: "4px",
                                objectFit: "cover"
                              }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                            <span className="textOver mobCode" style={{ fontSize: "16px", fontWeight: 500 }}>
                              {selectedCountry.dial_code}
                            </span>
                          </div>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Menu
                    anchorEl={countryMenuAnchor}
                    open={Boolean(countryMenuAnchor)}
                    onClose={handleCountryMenuClose}
                    MenuListProps={{
                      style: { maxHeight: 300, zIndex: 99999 },
                    }}
                    PaperProps={{
                      style: { maxHeight: 300 },
                    }}
                  >
                    {Countries.map((country) => (
                      <MenuItem 
                        key={country.code} 
                        onClick={() => handleCountryChange(country.code)}
                        selected={selectedCountry.code === country.code}
                      >
                        <div className="d-flex align-items-center">
                          <img
                            src={country.flag}
                            alt={country.name}
                            style={{
                              width: "24px",
                              height: "18px",
                              marginRight: "8px",
                              objectFit: "cover"
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                          <span className="px-2">{country.name}</span>
                          <span className="text-muted">{country.dial_code}</span>
                        </div>
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              </div>
              <div
                className={`row mt-3  ${
                  appState.langValue === "ar" ? "classforArabicTextField" : ""
                }`}
              >
                <div className="col-12">
                  <TextField
                    className="mt-1"
                    label={
                      (appState.hotelMode &&
                        checkNameRequired(
                          JSON.parse(getCookie("hotelInfo"))
                        )) ||
                      deliveryCheckoutUrl
                        ? t("Forms.fullNameReq")
                        : t("Forms.fullName")
                    }
                    type="text"
                    name="fullName"
                    value={loginValues?.fullName}
                    onChange={updateField}
                    variant="outlined"
                    autoComplete="off"
                    required={
                      (appState.hotelMode &&
                        checkNameRequired(
                          JSON.parse(getCookie("hotelInfo"))
                        )) ||
                      deliveryCheckoutUrl
                    }
                  />
                </div>
              </div>
              <div
                className={`row mt-3  ${
                  appState.langValue === "ar" ? "classforArabicTextField" : ""
                }`}
              >
                <div className="col-12">
                  <TextField
                    className="mt-1"
                    label={appState.deliveryMode && t("Forms.email")}
                    type="email"
                    name="email"
                    value={loginValues?.email}
                    onChange={updateField}
                    variant="outlined"
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>

            {appState.storeInfo.allowLogin != "1" &&
              appState.deliveryMode &&
              deliveryCheckoutUrl &&
              (appState.pickupOrDelivery == "pickup" ||
                appState.pickupOrDelivery == "delivery") && (
                <div className="classforBtnPadding">
                  <div className="row my-2">
                    <div className="col-12 d-flex justify-content-center align-items-center flex-column textf4f4">
                    <Button
                        onClick={handleGuestLogin}
                        className={`w-100 fontSize0P9rem blackBtn  bgEnabill   fontSize1rem mt-2 py-3 textCapitalized familyManrope800  ${loading || !validatePhoneNumber(loginValues.phoneNumber, selectedCountry.code).isValid ? "disabled-btn" : ""} `}
                        variant="contained"
                        disabled={loading || !validatePhoneNumber(loginValues.phoneNumber, selectedCountry.code).isValid}
                      >
                        {t("Continue as a Guest")}
                      </Button>

                      <p className="mt-4 mb-0">{t("OR")}</p>
                      
                      {/* <p onClick={handleGuestLogin} className="w-100 fontSize0P9rem btnEnabill2  my-0 text-center  familyManrope800 cursor-pointer ">
                      {t("Continue as a Guest")}a
                    </p> */}
                    </div>
                  </div>
                </div>
              )}

            <div className="classforBtnPadding">
              <div className="row my-3">
                <div className="col-12">
                  <Button
                    className={`blackBtn btnEnabill3 fontSize1rem  py-3 textCapitalized familyManrope800  ${loading || !validatePhoneNumber(loginValues.phoneNumber, selectedCountry.code).isValid ? "disabled-btn" : ""} `} 
                    variant="contained"
                    type="submit"
                    disabled={loading || !validatePhoneNumber(loginValues.phoneNumber, selectedCountry.code).isValid}
                  >
                    {loading
                      ? t("Login.redirecting")
                      : appState.deliveryMode && deliveryCheckoutUrl
                      ? t("Continue")
                      : t("Login.Verify")}
                  </Button>
                </div>
              </div>
            </div>
            {/* skip button for logged in users */}
            {(appState.storeInfo.allowLogin == "3" &&
              !appState.openBill &&
              !appState.deliveryMode) ||
            appState.storeInfo.lavazzaStoreOptions ? (
              <div className="classforBtnPadding">
                <div className="row my-3">
                  <div className="col-12">
                    <p
                      onClick={handleSkip}
                      className="w-100 fontSize0P9rem btnEnabill2  my-0 text-center textCapitalized familyManrope800 cursor-pointer "
                    >
                      {" "}
                      {t("checkOut.Skip")}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

           
          </form>

          <div className="row mt-4 ">
            <div
              className={`col-12 ${
                appState.langValue === "ar" ? "text-right" : ""
              }`}
            >
              <p className="familyManrope600 notRegisterMain mb-14 ">
                <span>
                  <img className="img-fluid" src={IMAGES.union} alt="" />
                </span>
                <span className="notRegister px-2">
                  {" "}
                  {t("Forms.Save-your-cards")}
                </span>
              </p>

              {min450 && <hr />}

              <p className="familyManrope600 notRegisterMain mb-14">
                <span>
                  <img className="img-fluid" src={IMAGES.newsPaper} alt="" />
                </span>
                <span className="notRegister px-2">
                  {" "}
                  {t("Forms.Tap-to-re-order")}
                </span>
              </p>

              {min450 && <hr />}

              <p className="familyManrope600 notRegisterMain mb-14">
                <span>
                  <img className="img-fluid" src={IMAGES.giftPaper} alt="" />
                </span>
                <span className="notRegister px-2">
                  {t("Forms.Get-discounts-and-cashbacks")}
                </span>
              </p>
              {min450 && <hr />}
            </div>
          </div>

          <div className="row ">
            <div className={`col-12 ${appState.langValue === "ar" ? "" : ""}`}>
              <p
                className={`familyManrope600 termsAndCondition text-center ${
                  appState.langValue === "ar" ? "direction-ltr" : ""
                }`}
              >
                <span className="textf9f9">
                  <DoneIcon /> {t("Forms.Terms-&-Conditions-apply")}
                </span>
              </p>

              <p
                className={`familyManrope rights-reserved m-0 ${
                  appState.langValue === "ar" ? "text-right" : ""
                }`}
              >
                © {year} {t("Forms.Enabill-All-rights-reserved")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(LoginModalv2Popup);
